import { Injectable, effect, inject } from '@angular/core';
import { AuthTokenService } from '@core/auth/auth-token.service';
import { AuthRefreshService } from './auth-refresh.service';

@Injectable()
export class TokenRefreshSchedulerService {
  private readonly tokenService = inject(AuthTokenService);
  private readonly refreshService = inject(AuthRefreshService);
  private readonly BUFFER_MS = 60_000;
  private timer: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    effect(() => {
      const tokens = this.tokenService.tokens();
      this.cancel();
      if (tokens?.accessTokenExpiresAtUtc && tokens.refreshToken) {
        this.scheduleRefresh(tokens.accessTokenExpiresAtUtc);
      }
    });
  }

  private scheduleRefresh(expiresAtUtc: string): void {
    const delay = new Date(expiresAtUtc).getTime() - Date.now() - this.BUFFER_MS;
    if (delay <= 0) {
      this.doRefresh();
      return;
    }
    this.timer = setTimeout(() => this.doRefresh(), delay);
  }

  private doRefresh(): void {
    this.refreshService.refresh().subscribe({ error: () => {} });
  }

  private cancel(): void {
    if (this.timer !== null) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}
